export default {
  SESSION_LIST_REQUEST: 'APP/SESSION/SESSION_REQUEST',
  SESSION_LIST_SUCCESS: 'APP/SESSION/SESSION_SUCCESS',
  SESSION_LIST_ERROR: 'APP/SESSION/SESSION_ERROR',
};
